import React, { useState, useEffect, Fragment } from 'react';
// import AppSlider from '../containers/AppClassic/AppSlider';
import Layout from '../components/layout';
import TopbarBackground from '../components/topbarBackground';
import SEO from '../components/seo';
// import InfoSection from '../containers/SaasModern/Info';
import FeatureSection1 from '../containers/FeaturesSection1';
import FeatureSection2 from '../containers/FeaturesSection2';
import FeatureSection3 from '../containers/FeaturesSection3';
import FeatureSlider from '../containers/App/FeatureSlider';
// import FeatureSlider from '../containers/FeaturesSection3/sliderWithImage';
// import AppSlider from '../containers/AppClassic/AppSlider';
// import FeatureTab from '../containers/AppClassic/FeatureTab';
import Section5 from '../containers/Hosting/Features';
import JoinTrail from '../containers/AppClassic/JoinTrail';

export default () => {
  return (
    <Layout>
      <SEO title="Free Customizable Chat Messaging Platform, Chat SDK and API for Mobile and PC Games and Apps | Features" />
      <TopbarBackground />

      <div id="chat_and_messaging">
        <FeatureSection1 />
      </div>
      <div id="our_services">
        <FeatureSection2 />
      </div>
      <div id="differentiation">
        <FeatureSection3 />
      </div>
      <div id="optional_features">
        <Section5 />
      </div>
      <div>
        <JoinTrail />
      </div>
      {/* <FeatureTab /> */}
      {/*
       */}
    </Layout>
  );
};
